export default __webpack_public_path__ + "static/media/purpledumbbells.158d5446.png";